// extracted by mini-css-extract-plugin
module.exports = {"comments-request":"_166IJL54oSO3WKGQL4F1yK","comments-request__buttons-bar":"_3Zl-ksXktFnEvAwFsgeqQG"};